import info from '../../subassembly/info'
import progressM from '../../subassembly/progress'
import survey from '../../subassembly/survey'
import transportOverview from '../../subassembly/transportOverview'
import frontconrtM from '../../subassembly/frontconrt'
import backconrtM from '../../subassembly/backconrt'

import alarm from '../../subassembly/alarm'
export default {
    components: {
        info,
        progressM,
        survey,
        transportOverview,
        frontconrtM,
        backconrtM,
        alarm,
    },
    data() {
        return {
            onlyOneImg:1
        }
    },
    created() {

    },
    mounted() {
    },
    methods: {
        changeImg(val) {
            this.onlyOneImg = val
            console.log(this.onlyOneImg)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/swLayer/swLayer-mixins.js